import {
	EmailTemplate,
	EmailTemplateMappings,
	RelatedEntityType,
} from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";

export const getEmailTemplates = async (): Promise<EmailTemplate[]> => {
	const { data } = await privateAxios.get<EmailTemplate[]>("/email-templates");
	return data;
};

export const useGetEmailTemplates = () => {
	return useQuery({
		queryKey: ["email-templates"],
		queryFn: getEmailTemplates,
	});
};

export const getEmailTemplatesByEntity = async (
	entityType: RelatedEntityType,
): Promise<EmailTemplate[]> => {
	const { data } = await privateAxios.get<EmailTemplate[]>(
		`/email-templates/by-entity/${entityType}`,
	);
	return data;
};

export const useGetEmailTemplatesByEntity = (entityType: RelatedEntityType) => {
	return useQuery({
		queryKey: ["email-templates", "by-entity", entityType],
		queryFn: () => getEmailTemplatesByEntity(entityType),
	});
};

export const getEmailTemplate = async (id: string): Promise<EmailTemplate> => {
	const { data } = await privateAxios.get<EmailTemplate>(
		`/email-templates/${id}`,
	);
	return data;
};

export const useGetEmailTemplate = (id: string) => {
	return useQuery({
		queryKey: ["email-templates", id],
		queryFn: () => getEmailTemplate(id),
		enabled: !!id,
	});
};

export const getEmailTemplateMappings =
	async (): Promise<EmailTemplateMappings> => {
		const { data } = await privateAxios.get<EmailTemplateMappings>(
			"/email-templates/mappings",
		);
		return data;
	};

export const useGetEmailTemplateMappings = () => {
	return useQuery({
		queryKey: ["email-templates", "mappings"],
		queryFn: getEmailTemplateMappings,
	});
};

export const validateEmailTemplate = async (
	id: string,
): Promise<{ valid: boolean; invalidFields: string[] }> => {
	const { data } = await privateAxios.post<{
		valid: boolean;
		invalidFields: string[];
	}>(`/email-templates/${id}/validate`);
	return data;
};

export const previewEmailTemplate = async (
	id: string,
	entityId?: string,
	overrides?: Record<string, unknown>,
): Promise<{ subject: string; htmlContent: string }> => {
	const params = new URLSearchParams();
	if (entityId) {
		params.append("entityId", entityId);
	}
	if (overrides) {
		params.append("overrides", JSON.stringify(overrides));
	}

	const { data } = await privateAxios.get<{
		subject: string;
		htmlContent: string;
	}>(`/email-templates/${id}/preview?${params.toString()}`);
	return data;
};
